import resolve from 'ioc/resolve'
import basicController from 'servicestack/basic.controller.properties'
import templateUrl from 'emun.on-demand/layers/design-layer-font-picker.htm'
import webfonts from 'webfonts/webfonts'
import FontService from 'emun.on-demand/lib/design-layer.fonts'


class DesignLayerFontPickerController {
    constructor() {
        basicController(this)
        var $ctrl = this;

    }
    $onInit() {
        var $ctrl = this;
        $ctrl.fonts = new FontService($ctrl.layer);
    }
}

let DesignLayerFontPicker = {
    bindings: {
        layer : '<',
        onSelected: '&'
    },
    controller: DesignLayerFontPickerController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default DesignLayerFontPicker;